import React from 'react';
import { SketchPicker } from 'react-color';
import PropTypes from 'prop-types';
import './ColorPicker.less';
import UserContext from '../../pages/layout/UserContext';
import checkPermission from '../Authorization/Util';

class ColorPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false,
      color: '#EFEFEF',
    };
  }

  componentDidMount() {
    const { record } = this.props;
    
    if (record && record.color) {
      this.setState({
        color: record.color,
      });
    } else {
      this.setState({
        color: '#EBE5E5',
      });
    }
  }

  handleClick = () => {
    const { displayColorPicker } = this.state;
    this.setState({ displayColorPicker: !displayColorPicker });
  };

  handleClose = () => {
    const value = this.context;
    this.setState({ displayColorPicker: false });
    const { record } = this.props;
    const updatedRecord = record;
    const { color } = this.state;
    // todo: if color did not changed do not make a call
    updatedRecord.color = color;
    if (checkPermission(value, 'setting', 'write')) {
      
      const { saveRecord } = this.props;
      saveRecord(updatedRecord, updatedRecord.id);
    }
  };

  handleChange = color => {
    
    this.setState({ color: color.hex });
  };

  render() {
    const { displayColorPicker, color } = this.state;
    return (
      <div>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div className="swatch" onClick={this.handleClick}>
          <div className="color" style={{ background: color }} />
        </div>
        {displayColorPicker ? (
          <div className="popover">
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div className="cover" onClick={this.handleClose} />
            <SketchPicker color={color} onChange={this.handleChange} />
          </div>
        ) : null}
      </div>
    );
  }
}

ColorPicker.propTypes = {
  record: PropTypes.object,
  saveRecord: PropTypes.func,
};

ColorPicker.contextType = UserContext;

export default ColorPicker;
